import type { RouteRecordRaw } from "vue-router";
import { APP_CHAT_CUSTOMER_ROUTES } from "@/Generated/Routes/paths";

const CustomerRoutes: RouteRecordRaw[] = [
  {
    ...APP_CHAT_CUSTOMER_ROUTES.breaks.root,
    component: () => import("@/Views/chat/customer/views/Breaks/Breaks.vue"),
    meta: {
      i18nTitle: "user.settings.customer.breaks",
    },
  },
  {
    ...APP_CHAT_CUSTOMER_ROUTES.breaks.registerBreak.root,
    component: () => import("@/Views/chat/customer/views/Breaks/RegisterBreak.vue"),
    meta: {
      i18nTitle: "user.settings.customer.new_break",
    },
  },
];

export default CustomerRoutes;
